/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2024-03-20 16:56:36
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2025-05-19 10:50:06
 * FilePath     :\AV-COM-user-backend\src\router\index.js
 * RevisionHistory:
 */
import Vue from "vue";
import VueRouter from "vue-router";
// import {crea} from "vue-router"
// import { getUserInfo } from "@/api/index";
// import Login from "@/views/login/Login";

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};
// let preLang = "/:lang(de|fr|jp|tw|es|it|cn)?";
// let preLang = "";
// if (window.location.host === "www.anyviewer.cn") {
//     preLang = "";
// }
const routes = [
    {
        name: "login",
        path: "/login",
        component: () => import("@/views/login"),
    },
    {
        path: "/third-party",
        component: () =>
            import("@/views/userInfo/accountInfo/thirdPartyTransfer.vue"),
    },
    {
        path: "/user/third-party",
        component: () =>
            import("@/views/userInfo/accountInfo/thirdPartyTransfer.vue"),
    },
    // {
    //     path: "*",
    //     redirect: "/login",
    // },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
